<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div class="card">
	<div class="card-header bg-theme mb-0">
		<h5 class="card-title text-light mb-0">
			{{pagetitle}}
			<button class="btn btn-xs btn-secondary float-end" matTooltip="Excel" [disabled]="caseExcelLoader"
				(click)="getExcel()">
				<fa-icon *ngIf="!caseExcelLoader" [icon]="['fas', 'cloud-download-alt']"></fa-icon>
				<fa-icon *ngIf="caseExcelLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
			</button>
		</h5>
	</div>
	<div class="card-body pt-0">
		<mat-accordion [hideToggle]="false">
			<mat-expansion-panel [expanded]="false">
				<mat-expansion-panel-header class="bg-secondary" [collapsedHeight]="'35px'" [expandedHeight]="'40px'">
					<mat-panel-title>
						<strong class="text-white">
							<fa-icon [icon]="['fas','filter']"></fa-icon>
							Advanced Search
						</strong>
					</mat-panel-title>
					<mat-panel-description>
					</mat-panel-description>
				</mat-expansion-panel-header>
				<div class="row g-1 mt-1">
					<div class="col-md-4">
						<ng-select [items]="caseStatusList" bindLabel="name" bindValue="id" [clearable]="true"
							[(ngModel)]="filters.case_status" placeholder="Case Status" [appearance]="'outline'"
							(change)="refreshTable();" appendTo="body">
						</ng-select>
					</div>
					<div class="col-md-4">
						<ng-select [items]="allCaseCategories" bindValue="id" bindLabel="name" [clearable]="true"
							placeholder="Case Category" [(ngModel)]="filters.case_category" appearance="outline"
							(change)="refreshTable();" appendTo="body">
						</ng-select>
					</div>
					<div class="col-md-4">
						<div class="w-50 float-start pe-1">
							<div class="input-group">
								<div class="form-floating">
									<input class="form-control" placeholder="" [(ngModel)]="filters.from_date"
										ngbDatepicker id="from_date" #from_date="ngbDatepicker" [minDate]="minDate"
										[container]="'body'" (ngModelChange)="refreshTable()" />
									<label for="from_date">From</label>
								</div>
								<button class="btn btn-outline-secondary" (click)="from_date.toggle()" type="button">
									<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
								</button>
							</div>
						</div>
						<div class="w-50 float-start ps-1">
							<div class="input-group">
								<div class="form-floating">
									<input class="form-control" placeholder="" [(ngModel)]="filters.to_date"
										ngbDatepicker id="to_date" #to_date="ngbDatepicker" [minDate]="minDate"
										[container]="'body'" (ngModelChange)="refreshTable()" />
									<label for="to_date">To</label>
								</div>
								<button class="btn btn-outline-secondary" (click)="to_date.toggle()" type="button">
									<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
								</button>
							</div>
						</div>
					</div>
				</div>
			</mat-expansion-panel>
		</mat-accordion>
		<div class="table-responsive">
			@if(dtOptions.pagingType){
			<table datatable [dtOptions]="dtOptions" class="table table-striped table-bordered table-hover appt-table"
				style="width: 100%;border: 1px solid rgb(187, 187, 187);">
				<thead>
					<tr class="table_head">
						<th style="width: 7%;">Case ID</th>
						<th style="width: 10%;">Vessel</th>
						<th style="width: 15%;">Crew Name</th>
						<th style="width: 8%;">Rank</th>
						<th style="width: 8%;">Arrival Date</th>
						<th style="width: 8%;">Fitness Date</th>
						<th style="width: 6%;">Days to Recover</th>
						<th style="width: 5%;" class="text-center">Case Status</th>
						<th style="width: 6%;">Case Category</th>
						<th style="width: 7%;">Expected Closure Date</th>
						<th style="width: 10%;">Diagnosis</th>
						<th style="width: 10%;">Was Crew Hospitalised</th>
					</tr>
				</thead>
				<tbody *ngIf="dataList?.length != 0">
					<tr *ngFor="let v of dataList;let i = index;">
						<td>
							{{v.case_id}}
							<!-- <a [routerLink]="['/comp/appt-details',v.enc_id]" matTooltip="Details">
								{{v.case_id}}
							</a> -->
						</td>
						<td>{{ v.vessel?.vessel_name }}</td>
						<td>{{ v.candidate.f_name }} {{ v.candidate.l_name }}</td>
						<td>{{ v.rank?.rank }}</td>
						<td>{{ v.arrival_date }}</td>
						<td>{{ v.fitness_date }}</td>
						<td>{{ v.case_days_by_fitness_date }}</td>
						<td class="text-center">
							<fa-icon [icon]="['fas',v.status_id==2?'lock':'lock-open']"
								matTooltip="{{ v.status_name }}"></fa-icon>
						</td>
						<td>{{ v.case_category?.name }}</td>
						<td>{{ v.expected_closure_date }}</td>
						<td>{{ v.diagnosis }}</td>
						<td>{{ v.other_details?.hospitalization_status }}</td>
					</tr>
				</tbody>
				<tbody *ngIf="dataList?.length == 0">
					<tr>
						<td colspan="12" class="text-center">No data found!</td>
					</tr>
				</tbody>
			</table>
			}
		</div>
	</div>
</div>